// Backend
import React from 'react';

// Frontend
import { Grid, Cell } from 'react-foundation';
import JourneySteps from '../../components/JourneySteps';
import DemoStartButton from '../../components/DemoStartButton';
import '../../stylesheets/components/Pages.css';

// Functionality
import { useLocation, Link } from 'react-router-dom';

// Components
import { Header, FlashMessage } from '../../constants/SharedComponents';
import useCurrentUser from '../../hooks/useCurrentUser';
import { useDemoContext } from '../../contexts/DemoContext';
import BackToDashboardButton from '../../components/BackToDashboardButton';

export function PagesHowToUse() {
  // API
  const currentUser = useCurrentUser();
  const { isDemoMode } = useDemoContext();
  const { state } = useLocation();

  // Objects
  const [flashMessageObject, setFlashMessageObject] = React.useState({});

  // @see https://css-tricks.com/run-useeffect-only-once/#
  // The second param will ensure the useEffect only runs once.
  // eslint-disable-next-line
  React.useEffect(() => {
    if (state?.hasOwnProperty('flash')) {
      setFlashMessageObject(state.flash);
    }
  }, [currentUser, state]);

  return (
    <>
      <Header />
      <FlashMessage object={flashMessageObject} columnWrap={true} />

      <div className="grid-container">
        <Grid className="grid-padding-x align-justify">
          <Cell small={12}>
            <div className="page-content">
              <BackToDashboardButton />
              <h1 className="page-content__title">
                An introduction to Forward Together &trade;
              </h1>
            </div>
          </Cell>
          <Cell small={12} large={12}>
            <div className="page-content">
              <div className="page-content__styles">
                <p>
                  The Forward Together is an interactive platform that supports a manager and their team member through 
                  a guided discussion about the challenges the team member faces in their work. 
                  The aim is to help them move forward together on these challenges. 
                  The manager and the team member will be guided through their journey. 
                  Interact with the chart below to know the steps you need to undertake.
                </p>
                <p>
                  The team member can choose what they share and a record is then created that can
                  be viewed and discussed again at various stages.
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '20px', alignItems: 'flex-start' }}>
                  <p>
                    A key part of the tool is the conversation canvas. You can practice using the canvas without any data to be recorded with our Canvas Demo
                  </p>
                  <Link 
                    to={isDemoMode ? `/demo/canvas` : `/canvases/test/edit`} 
                    className="page-content__button--medium compact-button"
                    style={{ textAlign: 'center' }}
                  >
                    Try Canvas Demo
                  </Link>
                  <DemoStartButton variant="secondary" className="compact-demo-button" />
                </div>
              </div>
            </div>
          </Cell>
		   <Cell small={12} large={12}>
            <JourneySteps />
          </Cell>
        </Grid>
      </div>
    </>
  );
}
